<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterStatusSchedule' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasStatusSchedule">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="status in statusSchedule"
              :key="status.id"
            >
              <CardStatusSchedule :statusSchedule="status" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardStatusSchedule from "@/views/Professional/components/CardStatusSchedule";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Listar status dos agendamentos",
          routerName: "ListStatusSchedule",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      statusSchedule: "Professional/statusSchedule",
    }),
    hasStatusSchedule() {
      return (
        this.statusSchedule &&
        Array.isArray(this.statusSchedule) &&
        this.statusSchedule.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardStatusSchedule,
  },
  methods: {
    ...mapActions("Professional", ["consultStatusSchedule"]),
  },
  mounted() {
    this.consultStatusSchedule();
  },
};
</script>
